import { useMoneyCurrency } from '../../components/money/MoneyProvider.js';
import { formatMoney, multiplierFor, toMinorUnits } from './index.js';

/**
 * Hook that provides money helpers bound to the active currency.
 *
 * Uses the MoneyProvider context currency as the default; callers may
 * pass an explicit `currency` to override for a specific scope.
 */
export function useMoney(currency?: string) {
  const fallback = useMoneyCurrency();
  const ccy = currency ?? fallback;
  return {
    currency: ccy,
    toMinor: (s: string | number) => toMinorUnits(String(s), ccy),
    fromMinor: (n: bigint | number) => formatMoney(n, ccy),
    multiplier: () => multiplierFor(ccy),
  };
}
